import React, {useEffect, useState} from 'react';
import {Viewer} from 'photo-sphere-viewer';
import MarkersPlugins from 'photo-sphere-viewer/dist/plugins/markers';
import GyroscopePlugin from 'photo-sphere-viewer/dist/plugins/gyroscope';
import StereoPlugin from 'photo-sphere-viewer/dist/plugins/stereo';
import 'photo-sphere-viewer/dist/photo-sphere-viewer.css';
import 'photo-sphere-viewer/dist/plugins/markers.css';

import Shape from './../../assets/img/sphere.jpeg';
import Info from './../../assets/img/info.png';
import Loading from './../../assets/img/load360.gif';
import {makeStyles} from '@material-ui/core/styles';
import Api from '../../config/api';

const useStyles = makeStyles((theme) => ({
  hotspot: {
    backgroundImage: `url(${Info})`,
    height: 50,
    width: 50,
  },
}));

function App(props) {
  const nop = props.match.params.nop;
  const [dataOp, setDataOp] = useState([]);

  const nm_wp_sppt = dataOp.nm_wp_sppt;
  const jln_wp_sppt = dataOp.jln_wp_sppt;
  const nm_kecamatan = dataOp.nm_kecamatan;
  const nm_kelurahan = dataOp.nm_kelurahan;
  const luas_bumi_sppt = dataOp.luas_bumi_sppt;
  const luas_bng_sppt = dataOp.luas_bng_sppt;
  const kd_kls_tanah = dataOp.kd_kls_tanah;
  const kd_kls_bng = dataOp.kd_kls_bng;

  const classes = useStyles();

  useEffect(() => {
    Api.get('gis/detail/nop', {
      nop: nop,
    }).then(function (response) {
      if (response) {
        if (response.data) {
          setDataOp(response.data.op);
        }
      }
    });

    const shperePlayerInstance = new Viewer({
      container: document.querySelector('#viewer'),
      caption: nop,
      panorama: Shape,
      loadingImg: Loading,
      mousewheel: true,
      touchmoveTwoFingers: true,
      navbar: ['autorotate', 'zoom', 'gyroscope', 'stereo', 'caption', 'fullscreen'],
      size: {
        width: '100vw',
        height: '100vh',
      },
      plugins: [
        GyroscopePlugin,
        StereoPlugin,
        [
          MarkersPlugins,
          {
            markers: [
              {
                id: 'image',
                longitude: 0,
                latitude: 0,
                anchor: 'bottom center',
                tooltip: `
                    <div>${nop}</div >
                `,
                image: Info,
                height: 45,
                width: 45,
              },
            ],
          },
        ],
      ],
    });

    const markersPlugin = shperePlayerInstance.getPlugin(MarkersPlugins);
    markersPlugin.on('select-marker', (e, marker) => {
      // console.log(`Cursor is over marker ${marker.id}`);
    });

    shperePlayerInstance.on('position-updated', (e, position) => {
      // console.log(
      //   `new position is longitude: ${position.longitude} latitude: ${position.latitude}`,
      // );
    });
  }, [nop]);

  return <div id="viewer" />;
}

export default App;
